import { QueryClient as ReactQueryClient } from '@tanstack/react-query'

export const QueryClient = new ReactQueryClient()

export const QueryClientProvider = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>
}
